"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const react_select_1 = __importDefault(require("react-select"));
require("./selector.scss");
const displayWrapper_1 = require("./common/displayWrapper");
const selectorOption_1 = require("./common/selectorOption");
const NormalMultipleSelector = ({ options, onChange, value, ignoreValues, }) => {
    var _a;
    const convertedOptions = (0, react_1.useMemo)(() => options.map(({ title: label, value }) => ({
        value,
        label,
    })), [options]);
    const convertedOptionMap = (0, react_1.useMemo)(() => {
        return new Map(convertedOptions.map((item) => [item.value, item]));
    }, [convertedOptions]);
    return (react_1.default.createElement(react_select_1.default, { isMulti: true, options: convertedOptions, value: (_a = value === null || value === void 0 ? void 0 : value.map) === null || _a === void 0 ? void 0 : _a.call(value, (value) => convertedOptionMap.get(value)), onChange: (options, meta) => {
            var _a, _b;
            if (meta.action === "select-option" &&
                (ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.has(((_a = meta.option) === null || _a === void 0 ? void 0 : _a.value) || null))) {
                onChange([((_b = meta.option) === null || _b === void 0 ? void 0 : _b.value) || null]);
            }
            else {
                const newValue = options
                    .map((option) => option === null || option === void 0 ? void 0 : option.value)
                    .filter((value) => value != null && !(ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.has(value)));
                onChange(newValue.length > 0 ? newValue : undefined);
            }
        }, hideSelectedOptions: false, closeMenuOnSelect: false, blurInputOnSelect: false }));
};
const DescreteMultipleSelector = ({ options, onChange, value, uiType, hasError, ignoreValues, }) => {
    const valueSet = (0, react_1.useMemo)(() => new Set(Array.isArray(value) ? value : []), [value]);
    const optionMap = (0, react_1.useMemo)(() => {
        return new Map(options.map((item) => [item.value, item]));
    }, [options]);
    return (react_1.default.createElement("div", { style: { margin: "5px 0" }, className: (0, classnames_1.default)({
            "has-error": hasError,
        }, uiType && `selector-${uiType}`) }, options.map(({ title, value: optionValue }, index) => (react_1.default.createElement("span", { key: index, className: (0, classnames_1.default)("selectorOption", valueSet.has(optionValue) && "active"), onClick: (e) => {
            var _a, _b;
            if (ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.has(optionValue)) {
                if (optionValue != null) {
                    if (valueSet.has(optionValue)) {
                        valueSet.delete(optionValue);
                        onChange(undefined);
                    }
                    else {
                        valueSet.add(optionValue);
                        onChange(Array.from([optionValue]));
                    }
                }
            }
            else {
                if (optionValue != null) {
                    if (valueSet.has(optionValue)) {
                        valueSet.delete(optionValue);
                    }
                    else {
                        valueSet.add(optionValue);
                    }
                }
                (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
                const newValue = Array.from(valueSet).filter((value) => !(ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.has(value)));
                onChange(newValue.length > 0 ? newValue : undefined);
            }
        }, onMouseDown: (e) => e.preventDefault() }, title)))));
};
const defaultIgnoreValues = new Set([
    99,
    999,
    "99",
    "999",
    97,
    997,
    "97",
    "997",
]);
const MultipleSelectorSchemaComponent = (props) => {
    const { schema } = props;
    const { options, uiType } = schema;
    const { registerProps: { onChange }, value, fieldState, } = (0, core_1.useField)(props, [core_1.requiredValidator]);
    const ignoreValues = (0, react_1.useMemo)(() => {
        return schema.ignoreValues || schema.naValues
            ? new Set([...(schema.ignoreValues || []), ...(schema.naValues || [])])
            : defaultIgnoreValues;
    }, [schema]);
    const convertedOption = (0, selectorOption_1.useOptionIntl)(options);
    const sortedOptions = (0, react_1.useMemo)(() => {
        if (schema.randomize) {
            return convertedOption.sort((a, b) => {
                const aIsIgnore = ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.has(a.value);
                const bIsIgnore = ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.has(b.value);
                if (aIsIgnore && bIsIgnore) {
                    return 0;
                }
                else if (aIsIgnore) {
                    return 1;
                }
                else if (bIsIgnore) {
                    return -1;
                }
                else {
                    return Math.random() - 0.5;
                }
            });
        }
        else {
            return convertedOption;
        }
    }, [convertedOption, schema.randomize]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        uiType === "normal" && (react_1.default.createElement(NormalMultipleSelector, { options: sortedOptions, value: value, onChange: onChange, ignoreValues: ignoreValues })),
        uiType !== "normal" && (react_1.default.createElement(DescreteMultipleSelector, { options: sortedOptions, value: value, onChange: (e) => {
                console.log("e", e);
                onChange(e);
            }, uiType: uiType, hasError: fieldState.invalid, ignoreValues: ignoreValues }))));
};
MultipleSelectorSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MultipleSelectorDisplayComponent", (value, schema) => {
    const { options } = schema;
    const valueSet = (0, react_1.useMemo)(() => {
        try {
            return new Set(Array.isArray(value) ? value : [value]);
        }
        catch (e) {
            return new Set();
        }
    }, [value]);
    const convertedOption = (0, selectorOption_1.useOptionIntl)(options);
    return (react_1.default.createElement("div", { style: { lineHeight: "1.8em" } }, convertedOption
        .filter((option) => valueSet.has(option.value))
        .map((option, index, array) => {
        return (react_1.default.createElement("span", { key: index, style: {
                background: "#ddd",
                borderRadius: "7px",
                padding: "4px 10px",
                margin: "3px",
                fontSize: "0.8em",
                whiteSpace: "nowrap",
            } }, option.title));
    })));
});
exports.default = MultipleSelectorSchemaComponent;
